import React, { useState, useEffect, useRef } from "react";
import CustomNav from "../components/CustomNav";
import Footer from "../components/Footer";
import video from "../images/video.mp4";
import qhVideo from "../images/video.mp4";
import HomeProducts from "../components/HomeProducts";
import { FaVolumeUp, FaVolumeMute, FaPlay, FaPause } from "react-icons/fa";
import AOS from "aos";
import "aos/dist/aos.css";
import StatsSection from "../components/StatsSection";
import NewNav from "../components/NewNav";


function Home() {
  const [isLoading, setIsLoading] = useState(true);
  const [isMuted, setIsMuted] = useState(true);
  const videoRef = useRef(null);

  useEffect(() => {
    setTimeout(() => {
      setIsLoading(false);
    }, 4000);
    
    AOS.init({
      duration: 1000, // Animation duration ////...
      easing: "ease-in-out",
      once: true, // Ensures animation occurs only once //
    });
  }, []);

  const toggleMute = () => {
    videoRef.current.muted = !videoRef.current.muted;
    setIsMuted(videoRef.current.muted);
  };

  if (isLoading) {
    return (
      <div className="preloader" style={{ backgroundColor: "black", display: "flex", alignItems: "center", justifyContent: "center", height: "100vh", width: "100vw", position: "fixed", top: 0, left: 0, zIndex: 9999 }}>
        <h1 className="slogan" style={{ color: "white", textAlign: "center", fontSize: "2rem" }}>
          "Bringing Innovation to Light"
        </h1>
      </div>
    );
  }

  return (
    <div className="home-wrapper-page">
      {/* <CustomNav /> */}
      <NewNav/>
      
      {/* Video Section */}
      <section className="video-section mb-5" data-aos="fade-up">
        <div className="video-wrapper">
          <video ref={videoRef} src={video} autoPlay loop muted className="responsive-video" style={{ width: "100%", height: "auto", display: "block" }} />
          <div className="video-controls">
            <button className="control-btn" onClick={toggleMute}>
              {isMuted ? <FaVolumeMute /> : <FaVolumeUp />}
            </button>
          </div>
        </div>
      </section>
      {/* Content Section with AOS Animation */}
      <div className="container-fluid mb-3 p-0">   
          <HomeProducts />
      </div>
      <StatsSection/>
      <Footer />
    </div>
  );
}

export default Home;
